export default __webpack_public_path__ + "static/media/Balthus's Wolf Bow.4c0bf871.jpg";